import { catchError, switchMap, tap, throwError } from 'rxjs';
import AUTH_EXCEPTIONS from '../Infrastructure/Exception/APIv4AuthExceptionMap';
import { customerCredentials } from '../../Auth/Domain/Credentials';
/**
 *  TODO: this is a temporary solution, the infrastructure of the error check should be injected and not imported
 */
function authErrorCheck(error) {
  return AUTH_EXCEPTIONS.some(authException => error.message.includes(authException.exception.message));
}
/**
 *
 * @param context SamContext
 * @param callBackFunction The callback function you want to execute, the token will be injected as first argument
 * @returns Observable<T> Will return the callbackFuntion result
 */
export function credentialsHandler(context, callBackFunction) {
  return customerCredentials.getCredentials(context).pipe(switchMap(token => {
    return callBackFunction(token).pipe(tap(() => customerCredentials.setCredentials(context, token)), catchError(error => {
      if (authErrorCheck(error)) {
        customerCredentials.removeCredentials(context);
      }
      return throwError(() => error);
    }));
  }));
}
